<template>
  <LoaderSpinner class="fa-spin loader-icon mx-auto d-block" />
</template>

<script>
import LoaderSpinner from '~/static/icon_spinner.svg?inline';

export default {
  components: {
    LoaderSpinner,
  },
};
</script>

<style scoped lang="scss">
.loader-icon {
  height: 50px;
  width: 50px;
}
</style>
